import { isNil } from 'lodash';

export const toFixed2 = (num: string | number | null | undefined): number => {
  if (Number(num) === 0 || isNil(num) || isNaN(+num)) {
    return 0;
  } else {
    return Number.isInteger(num) ? +num : +Number(num)?.toFixed(2);
  }
};
